import { makeObservable, computed } from 'mobx';
import { NodeBaseDto } from '../../types';
import { NodeBaseModel, InputBaseModel, WorksheetModel } from '..';
import { SourceModelBase } from '../../../custom_shared/models';
import { InputFactory, InputIds } from '../../misc';

export default class GeneralInformationNodeModel extends NodeBaseModel {
    inputs: InputBaseModel[] = [];

    constructor(data: NodeBaseDto, sources: SourceModelBase[], worksheet: WorksheetModel, parentNode?: NodeBaseModel) {
        super(data, worksheet, parentNode);

        this.inputs = InputFactory.createInputs(this, data.inputs, sources);

        makeObservable(this, {
            worksheetTitleInput: computed,
            worksheetStatusInput: computed,
            bookingYearInput: computed,
            bookingPeriodInput: computed
        });
    }

    update(data: NodeBaseDto, sources: SourceModelBase[]) {
        this.inputs = InputFactory.createOrUpdateInputs(this, this.inputs, data.inputs, sources);
    }

    get name() {
        return 'General Information';
    }

    get worksheetTitleInput() {
        return this.getInputById(InputIds.GeneralInformationNode.WorksheetTitle);
    }

    get worksheetStatusInput() {
        return this.getInputById(InputIds.GeneralInformationNode.WorksheetStatus);
    }

    get bookingYearInput() {
        return this.getInputById(InputIds.GeneralInformationNode.BookingYear);
    }

    get bookingPeriodInput() {
        return this.getInputById(InputIds.GeneralInformationNode.BookingPeriod);
    }

    get dto(): NodeBaseDto {
        return {
            id: this.id,
            type: this.type,
            inputs: this.inputs.map(input => input.dto),
            childNodes: this.childNodes.map(node => node.dto)
        };
    }
}
